import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, of } from "rxjs";
import { switchMap, take } from "rxjs/operators";

import { HaleonAuthService } from "../services";
import { HALEON_APP_HEADER } from "../constants";

@Injectable()
export class HaleonAuthInterceptor implements HttpInterceptor {
  constructor(private haleonAuthService: HaleonAuthService) {}

  private shouldIntercept(request: HttpRequest<unknown>): boolean {
    const isAuthEndpoint = request.url.includes("/haleon/auth");
    const isHalenonApp = request.headers.has(HALEON_APP_HEADER);
    return !isAuthEndpoint && isHalenonApp;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Skip intercepting the auth endpoint itself to prevent infinite loop
    if (!this.shouldIntercept(request)) {
      return next.handle(request);
    }

    return this.haleonAuthService.auth$.pipe(
      take(1),
      switchMap((auth) => (auth ? of(auth) : this.haleonAuthService.getAuth())),
      switchMap((auth) => {
        if (auth?.tokens?.access_token) {
          const authRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${auth.tokens.access_token}`,
            },
          });

          return next.handle(authRequest);
        }

        return next.handle(request);
      })
    );
  }
}
